import { useNavigate } from 'react-router';
import { authTokenService } from '@/bundle/shared/services/authTokenService';
import { getLoginPath } from '@/bundle/Auth/LoginFlow/LoginPage/path/path';

export const useAuthNavigateToLogin = () => {
  const navigate = useNavigate();

  const authNavigateToLogin = () => {
    authTokenService.removeTokens();
    navigate(getLoginPath());
  };

  return {
    authNavigateToLogin,
  };
};
